import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import loadable from '@loadable/component';
import {
    observeContainerDimensions,
} from '../Utils/ContainerSize';
import {
    useLocation,
} from 'react-router-dom';
import {
    useContainerSize,
} from '~SpectateStore/hooks/clientStateHooks';
import {
    useThemeMode,
} from '~SpectateStore/hooks/userHooks';
import 'normalize.css';
import '../styles/layout/layout.scss';
import '../styles/spectate-client.scss';
import BuildInfo from '~spa/Components/BuildInfo/BuildInfo';
import SeoNavigation from '~spa/Components/SeoNavigation/SeoNavigation';
import Modals from '~shared/components/modal-overlay/Modals';
import { isVirtualSportsPage } from '../Utils/VirtualSports';
import { loadSkinVariables } from '../Utils/Skins';
import { getThemeClass, pushGTMTheme } from '~spa/Utils/Skins';

const Betslip = loadable(
    () => import(/* webpackChunkName: "betslip" */ '~Betslip')
);

const SPECTATE_CLIENT_CLASS = 'spectateClient';
const BEM_CLASS = 'l';

const Layout = ({ children }) => {
    const size = useContainerSize();
    const themeMode = useThemeMode();
    const theme = getThemeClass(themeMode);
    const { pathname: currentUrlPath } = useLocation();

    useEffect(() => {
        pushGTMTheme();
        loadSkinVariables();
        observeContainerDimensions(size);
    }, []);

    const showSidebar = (url) => {
        return !isVirtualSportsPage(url);
    };

    const layoutClasses = classNames(
        SPECTATE_CLIENT_CLASS,
        theme,
        {
            [`${BEM_CLASS} ${BEM_CLASS}--${size}`]: showSidebar(currentUrlPath),
        }
    );

    return (
        <React.Fragment>
            <div className={layoutClasses}>
            <Modals />
                <main className={`${BEM_CLASS}__content`}>
                    <BuildInfo />
                    <SeoNavigation />
                    {children}
                </main>

                {/**
                 * We have extra logic to hide the betslip on Racing pages
                 * it was needed to implement in this hacky way as we don't
                 * have the URL's and the tab is rendered inside the container
                 * without rerendering the entire page
                 * tickets related:
                 * https://dedsert.atlassian.net/browse/AM-4327
                 * https://dedsert.atlassian.net/browse/AM-4155
                 * @see client/src/shared/components/react/VirtualSportWidget/VirtualSportWidget.jsx
                 */
                 !isVirtualSportsPage(currentUrlPath) && <aside className={`${BEM_CLASS}__sidebar`}>
                    <Betslip />
                </aside>}
            </div>
        </React.Fragment>
    );
};

Layout.propTypes = {
    children: PropTypes.node.isRequired,
};

export default Layout;
